// Third-party
import React from 'react';

// Components
import { HoldingIcon } from '../../common';

// Utils
import { enumerateArray, enumerateJSX, truncateString } from '../../../../utils/objects';
import { DISCLAIMER_TAG } from '../../../../utils/disclaimers/constants';
import { getCustomDisclaimersForItem } from '../../../../utils/disclaimers/comparison';
import { COMPARISON_ITEM_TYPES } from '../../../../utils/constants';
import { formatLocalizedString, formatMessageWithLocale } from '../../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';
import ComparisonItemType from '@/types/comparison-item-type';

type Props = {
  items: ComparisonItem[];
  locale?: Locale;
  short?: boolean;
  disclaimerTags?: DISCLAIMER_TAG[];
};

class InstrumentCustomDisclaimer extends React.Component<Props> {
  getHoldingIcon = (type: ComparisonItemType, color?: string) => (!color ? null : <HoldingIcon type={type} color={color} />);

  getNameElement = (item: ComparisonItem) => {
    const { locale } = this.props;

    const isSingleItem = item.type !== COMPARISON_ITEM_TYPES.PORTFOLIO && item.type !== COMPARISON_ITEM_TYPES.GROUP;
    const name: string | undefined = item.name[locale!];
    let label = truncateString(name != null ? name : '', 40);

    if (isSingleItem && item.holdings[0].symbol) {
      label = item.holdings[0].symbol;
    }

    return (
      <span key={item._id} className="item-name" data-private data-dd-privacy="mask">
        {this.getHoldingIcon(item.type, item.color)}
        {label}
      </span>
    );
  };

  render() {
    const { items, locale, disclaimerTags, short = false } = this.props;

    const customDisclaimers = items.filter(item => {
      if (
        !([COMPARISON_ITEM_TYPES.ALT, COMPARISON_ITEM_TYPES.FUND, COMPARISON_ITEM_TYPES.GROUP, COMPARISON_ITEM_TYPES.PORTFOLIO] as string[]).includes(item.type)
      ) {
        return false;
      }

      return getCustomDisclaimersForItem(item, disclaimerTags).length > 0;
    });

    if (customDisclaimers.length === 0) {
      return null;
    }

    if (short) {
      return (
        <span className="disclaimer">
          {formatMessageWithLocale('Disclaimers.CustomDisclaimer.Short.Prefix', locale)}
          {enumerateJSX(customDisclaimers.map(this.getNameElement), formatMessageWithLocale('Common.And', locale))}
          {formatMessageWithLocale('Disclaimers.CustomDisclaimer.Short.Suffix', locale)}
        </span>
      );
    }

    return (
      <>
        {customDisclaimers.map((item, i) => {
          const disclaimers = getCustomDisclaimersForItem(item, disclaimerTags).map(d => d.content);

          return (
            <span className="disclaimer" key={item._id}>
              {i === 0 && '*'}

              <span key={item._id}>
                <HoldingIcon color={item.color} type={item.type} />
                {'\xa0'}
                {enumerateArray(disclaimers.map(disclaimer => formatLocalizedString(disclaimer, locale)))}
              </span>
            </span>
          );
        })}
      </>
    );
  }
}

export default InstrumentCustomDisclaimer;
